import { useState } from "react";
import {
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Button,
} from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from "react-router-dom";

import SearchBar from "../../components/SearchBar";

interface UserData {
    id: number;
    username: string;
    email: string;
    phone: string;
    status: "In Process" | "Completed";
}

const Referral = () => {
    const navigate = useNavigate();

    const [searchTerm, setSearchTerm] = useState("");
 

    const [userData, setUserData] = useState<UserData[]>([
        {
            id: 1,
            username: "John Doe",
            email: "john@example.com",
            phone: "9876543210",
            status: "In Process",
        },
        {
            id: 2,
            username: "Sarah Smith",
            email: "sarah@example.com",
            phone: "9123456780",
            status: "Completed",
        },
    ]);

    // Search Filter
    const filteredData = userData.filter(
        (item) =>
            item.username.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.phone.includes(searchTerm) ||
            item.status.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <>
            <div className="main_title">
                <h1>Referrals</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Referrals
                </p>
            </div>
            <div className="stats_boxes gap_m">
                <a className="cards">
                    <h2>24</h2>
                    <p>Total Referrals</p>
                    <figure className="sucess">
                        <img src="/static/images/bag.svg" alt="Users" />
                    </figure>
                   
                </a>

                <a className="cards" >
                    <figure className="active_order">
                        <img src="/static/images/active_order.svg" alt="Active Users" />
                    </figure>
                    <h2>12</h2>
                    <p>Referrals In Progress</p>
                    
                </a>
                <a className="cards" >
                    <figure className="active_order">
                        <img src="/static/images/active_order.svg" alt="Active Users" />
                    </figure>
                    <h2>12</h2>
                    <p>Referrals Completed</p>
                    
                </a>

                <div className="cards">
                    <figure className="warning">
                        <img src="/static/images/reward_icon.svg" alt="Revenue" />
                    </figure>
                    <h2>1,247</h2>
                    <p>Total Bouteek Reward Points</p>
                  
                </div>
              
            </div>
            <div className="cards mt_20">

                {/* Search + Add */}
                <div className="table_header">
                    <div className="left_s">
                        <SearchBar
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setSearchTerm}
                            placeholder="Search..."
                        />
                    </div>
                    <div className="right_s">
                        <Button
                            className="btn btn_primary"
                            onClick={() => navigate("add")}
                        >
                            <AddIcon /> Add
                        </Button>
                    </div>
                </div>

                {/* Table */}
                <TableContainer className="table_container mt_20">
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Sr. No.</TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell>Email</TableCell>
                                <TableCell>Phone Number</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {filteredData.map((row, index) => (
                                <TableRow key={row.id} hover>
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell>{row.username}</TableCell>
                                    <TableCell>{row.email}</TableCell>
                                    <TableCell>{row.phone}</TableCell>
                                    <TableCell>{row.status}</TableCell>

                                    <TableCell>
                                        <div className="table_actions v2">
                                            <IconButton onClick={() => navigate("add")}>
                                                <img src="/static/images/edit2_icon.svg" alt="View" />
                                            </IconButton>

                                            <IconButton>
                                                <img src="/static/images/trash2_icon.svg" alt="Delete" />
                                            </IconButton>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}

                            {filteredData.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={6} align="center">
                                        No records found
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </>
    );
};

export default Referral;
